import type { Address } from "@jti/fe-common";
import type { MagentoRegion } from "@jti/magento-types";

const hasMatchingRegionCode = (regionCode: string, availableRegions: MagentoRegion[]) => {
  return availableRegions.some((region) => region.code === regionCode);
};

const hasMatchingRegion = (region: NonNullable<Address["region"]>, availableRegions: MagentoRegion[]) => {
  return availableRegions.some((availableRegion) => {
    return (
      availableRegion.id === region.region_id ||
      availableRegion.code === region.region_code ||
      availableRegion.name === region.region
    );
  });
};

export const sanitizeAddressRegionData = <T extends Address>(address: T, availableRegions?: MagentoRegion[]): T => {
  if (!availableRegions?.length) {
    return address;
  }

  const regionCode = address.regionCode?.trim();
  const hasValidRegionCode = !regionCode || hasMatchingRegionCode(regionCode, availableRegions);
  const hasValidRegion = !address.region || hasMatchingRegion(address.region, availableRegions);

  if (hasValidRegionCode && hasValidRegion) {
    return address;
  }

  return {
    ...address,
    ...(hasValidRegionCode ? {} : { regionCode: undefined }),
    ...(hasValidRegion ? {} : { region: undefined }),
  };
};
